<div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-12">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a [routerLink]="['/home']">Home</a>
        </li>
        <li class="breadcrumb-item">
          <a>Data Analysis</a>
        </li>
      </ol>
    </div>
</div>

<hr class="mb-4">

<div class="wrapper wrapper-content  animated fadeInRight">
    
    <div class="row">

        <div class="col-lg-8">
            <div class="ibox selected">
                <div class="ibox-content">

                    <tabset #tabs [justified]="true">
                        <tab heading="Select">
                            <div class="row mb-3 mt-3">
                                <div class="col-lg-12 card-body">
                                    <div class="input-group flex-nowrap">
                                        <input type="text" placeholder="Search time series by name..." class="form-control" [(ngModel)]="inputFilter" (keyup)="onSearchInput()" (keyup.enter)="doSearch(null)">
                                        <button type="button" class="btn btn-outline-default" (click)="doSearch(null)"  [disabled]="loading"><i class="bi bi-search"></i> </button>
                                    </div>
                                </div>
                            </div>
                            
                            
                            <div class="row">
                                <div class="d-flex fw-bold small filter-row">
                                    <span class="flex-grow-1">
                                        
                                        <pagination class="float-sm-left d-none d-lg-flex" *ngIf="allTimeSeries && allTimeSeries.length >= pageSize" [totalItems]="totalItems" [(ngModel)]="pageIndex" (pageChanged)="pageChange($event)" 
                                        [disabled]="loading" [maxSize]="maxPages" [itemsPerPage]="pageSize" ></pagination>
                                    </span>
                                    <span>
                                        <div class="btn-group form-group-sm float-sm-right filter-button d-none d-sm-inline" dropdown [isDisabled]="loading">
                                            <button id="button-basic" dropdownToggle type="button" class="btn btn-default btn-sm dropdown-toggle" aria-controls="dropdown-basic">
                                            Page Size : {{pageSize}} 
                                            </button>
                                            <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="button-basic">
                                                <li role="menuitem"><a class="dropdown-item" (click)="setPageSize(10)">10</a></li>
                                                <li role="menuitem"><a class="dropdown-item" (click)="setPageSize(25)">25</a></li>
                                                <li role="menuitem"><a class="dropdown-item" (click)="setPageSize(50)">50</a></li>
                                                <li role="menuitem"><a class="dropdown-item" (click)="setPageSize(100)">100</a></li>
                                            </ul>
                                        </div>
                                        <div class="btn-group form-group-sm float-sm-right filter-button" dropdown [isDisabled]="loading">
                                            <button id="button-sitetype" dropdownToggle type="button" class="btn btn-default btn-sm dropdown-toggle" aria-controls="dropdown-sitetype">
                                            Site Type : {{siteType.siteTypeCode}} 
                                            </button>
                                            <ul id="dropdown-sitetype" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="button-sitetype">
                                                <li role="menuitem"><a class="dropdown-item" (click)="setSiteType(siteTypeAny)">Any</a></li>
                                                <li role="menuitem" *ngFor="let st of siteTypes"><a class="dropdown-item" (click)="setSiteType(st)">{{st.siteTypeCode}}</a></li>
                                            </ul>
                                        </div>
                                        <div class="btn-group form-group-sm float-sm-right filter-button" dropdown [isDisabled]="loading">
                                            <button id="button-sitetype" dropdownToggle type="button" class="btn btn-default btn-sm dropdown-toggle" aria-controls="dropdown-sitetype">
                                            Data Type : {{inputType}} 
                                            </button>
                                            <ul id="dropdown-sitetype" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="button-sitetype">
                                                <li role="menuitem"><a class="dropdown-item" (click)="inputType = 'TimeSeries'">Time Series</a></li>
                                                <li role="menuitem"><a class="dropdown-item" (click)="inputType = 'Media'">Media</a></li>
                                            </ul>
                                        </div>
                                    </span>
                                </div>                                
                            </div>

                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th class="d-none d-lg-table-cell">Type <i (click)="columnSort('type')" class="{{columnSortStyle('type')}}"></i></th>
                                        <th class="d-none d-lg-table-cell">Site Type <i (click)="columnSort('siteType')" class="{{columnSortStyle('siteType')}}"></i></th>
                                        <th class="d-none d-sm-table-cell">Site Name <i (click)="columnSort('siteName')" class="{{columnSortStyle('siteName')}}"></i></th>
                                        <th>Name  <i (click)="columnSort('name')" class="{{columnSortStyle('name')}}"></i></th>
                                        <th class="d-none d-lg-table-cell">Location</th>
                                        <th class="d-none d-lg-table-cell">Latest Value <i (click)="columnSort('latest')" class="{{columnSortStyle('latest')}}"></i></th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>                                    
                                <tr *ngIf="(allTimeSeries == null || allTimeSeries.length == 0) && !loading && !searchStarted">
                                    <td colspan="7" class="start-search">
                                        <i class="fas fa-arrow-up"></i> 
                                        <i class="fas fa-arrow-up"></i> 
                                        Start your search above 
                                        <i class="fas fa-arrow-up"></i> 
                                        <i class="fas fa-arrow-up"></i> 
                                    </td>
                                </tr>              
                                <tr *ngIf="(allTimeSeries == null || allTimeSeries.length == 0) && !loading && searchStarted">
                                    <td colspan="7">No Time Series {{errorMessage}}</td>
                                </tr>                                
                                <tr *ngIf="(allTimeSeries == null || allTimeSeries.length == 0) && loading && searchStarted">
                                    <td colspan="7"><div class="spinner-border"></div></td>
                                </tr>
                                <!--<tr *ngFor="let _input of allTimeSeries | inputItemFilter:inputFilter">-->
                                <tr *ngFor="let _input of allTimeSeries | timeSeriesSort: sortColumn: sortDirection">
                                    <td class="d-none d-lg-table-cell">
                                        {{_input.type}}
                                    </td>
                                    <td class="d-none d-lg-table-cell">
                                        {{_input.siteType}}
                                    </td>                            
                                    <td class="d-none d-sm-table-cell" [title]="_input.siteUri">
                                        <ng-container *ngIf="_input.siteUri; else noSiteButton">
                                            <a (click)="this.selectSite(_input.siteUri)">{{_input.siteName}}</a>
                                        </ng-container>
                                        <ng-template #noSiteButton>
                                            {{_input.siteName}}
                                        </ng-template>
                                        <small class="d-xs-none" *ngIf="_input.siteDescription">
                                            <br/>
                                            ({{_input.siteDescription }})
                                        </small>
                                    </td>
                                    <td [title]="_input.uri">
                                        {{_input.name}}
                                        <small class="d-xs-none" *ngIf="_input.description">
                                            <br/>
                                            ({{_input.description}})
                                        </small>
                                    </td>
                                    <td class="d-none d-lg-table-cell">
                                        <span *ngIf="_input.latitudeTxt && _input.longitudeTxt">
                                        ({{_input.latitudeTxt}},{{_input.longitudeTxt}})
                                        </span>
                                    </td>                                    
                                    <td class="d-none d-lg-table-cell">
                                        {{_input.latestValue}}
                                        <i class="d-xs-none" *ngIf="_input.latestTime">
                                            <br/>
                                            {{_input.latestTime }}
                                        </i>
                                    </td>
                                    <td>
                                        
                                        <a *ngIf="this.azureAuthService.isDashboardEditor() && app.customer?.allowsAlarms && _input.virtualTimeSeriesId == null" class="btn btn-outline-link btn-sm mr-2 d-none d-lg-table-cell" type="button" (click)="this.openAlarmEditor(_input)">
                                            <i *ngIf="_input.alarms > 0" class="bi bi-bell-fill"></i>
                                            <i *ngIf="_input.alarms == 0" class="bi bi-bell"></i>
                                        </a>

                                        <button *ngIf="canAddTimeSeries(_input.uri, _input.type)" (click)="addTimeSeries(_input)" class="btn btn-outline-theme btn-sm float-right" type="submit" [title]="_input.uri" [attr.disabled]="analysis.timeSeriesList.length >= 20 ? true : null"><i class="bi bi-plus"></i></button>
                                        <button *ngIf="!canAddTimeSeries(_input.uri, _input.type)" (click)="removeTimeSeries(findTimeSeries(_input.uri))" class="btn btn-outline-danger btn-sm float-right" type="submit" [title]="_input.uri"><i class="bi bi-dash"></i></button>
                                        
                                     </td>
                                </tr>
                                </tbody>
                            </table>

                            

                        </tab>
                        <tab heading="Graph" [disabled]="true">
                            <div class="card mt-2 bg-emphasis bg-opacity-25">
                                <div class="card-body">
                                    <highcharts-chart [Highcharts]="Highcharts"
                                                    [constructorType]="stockConstructor"
                                                    [options]="chartOptions"
                                                    [callbackFunction]="chartCallback"                                              
                                                    style="width: 100%; height: 600px; display: block;"></highcharts-chart>

                                    <div class="card mt-2 bg-emphasis bg-opacity-30">
                                        <div class="card-body">                
                                            <div class="row">
                                                <div class="col-12 d-flex fw-bold small mb-3">
                                                    <span class="flex-grow-1">
                                                        <h4>Chart Options</h4>
                                                    </span>                    
                                                    <span>
                                                        <a class="collapse-link" (click)="showChartOptions = !showChartOptions">
                                                            <i class="bi" [ngClass]="{'bi-chevron-up':showChartOptions, 'bi-chevron-down':!showChartOptions}"></i>
                                                        </a>
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="row" *ngIf="showChartOptions">
                                                <div class="col-4">
                                                    <div class="form-group input-group-sm">
                                                        <label>Left Axis</label>
                                                        <div class="input-group">
                                                        <input type="number" placeholder="min" class="form-control" [(ngModel)]="analysis.leftMin" (change)="updateChart(true)"/>
                                                        <input type="number" placeholder="max" class="form-control" [(ngModel)]="analysis.leftMax" (change)="updateChart(true)"/>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-4">
                                                    <div class="form-group input-group-sm">
                                                        <label>Right Axis</label>
                                                        <div class="input-group">
                                                        <input type="number" placeholder="min" class="form-control" [(ngModel)]="analysis.rightMin" (change)="updateChart(true)"/>
                                                        <input type="number" placeholder="max" class="form-control" [(ngModel)]="analysis.rightMax" (change)="updateChart(true)"/>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row mt-2" *ngIf="showChartOptions">
                                                <div class="col-4">
                                                    <div class="form-group input-group-sm">
                                                        <label>Left Axis Title</label>
                                                        <input type="text" placeholder="Title..." class="form-control" [(ngModel)]="analysis.leftTitle" (change)="updateChart(true)"/>
                                                    </div>
                                                </div>
                                                <div class="col-4">
                                                    <div class="form-group input-group-sm">
                                                        <label>Right Axis Title</label>
                                                        <input type="text" placeholder="Title..." class="form-control" [(ngModel)]="analysis.rightTitle" (change)="updateChart(true)"/>
                                                    </div>
                                                </div>
                                                <div class="col-4">
                                                    <div class="form-group input-group-sm">
                                                        <label>Legend</label><br/>
                                                        <button class="btn btn-outline-default btn-sm" (click)="toggleLegend()" [ngClass]="{'active': showLegend}">
                                                            <i class="bi bi-list-ul"></i> {{showLegend ? 'Hide Legend' : 'Show Legend'}}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                       
                                    </div>  
                                </div>
                                
                            </div>  
                        </tab>
                        <tab heading="Table" [disabled]="true">
                            <div class="card mt-2 bg-emphasis bg-opacity-25">
                                <div class="card-body">
                                    <div *ngIf="orderedTimes && orderedTimes.length > 1000" class="alert alert-warning">
                                        Table view limited to first 1000 timestamps
                                    </div>
                                    <table class="table table-striped" *ngIf="analysis && analysis.timeSeriesList && analysis.timeSeriesList.length > 0">
                                        <thead>
                                        <tr>
                                            <th width="40px">#</th>
                                            <th width="280px">Time Stamp</th>
                                            <th *ngFor="let ts of analysis?.timeSeriesList">
                                                <span *ngIf="ts && ts.item" [style.color]="ts.colour">{{ts.item?.name}}</span>
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr *ngFor="let time of orderedTimesLimited; let i = index">
                                            <td>{{i}}</td>
                                            <td>{{time}}</td>
                                            <td *ngFor="let ts of analysis?.timeSeriesList">
                                                <div *ngVar="getPointForTime(time,ts) as variable">
                                                    <span *ngIf="variable">
                                                        <span style="white-space: pre-line" *ngIf="ts.item.type != 'Media'; else mediaBlock">
                                                            <span *ngIf="variable.valueStr && variable.valueStr.trim().startsWith('{'); else valueBlock">
                                                                <code>
                                                                    <pre>
                                                                        {{variable.valueStr}}
                                                                    </pre>
                                                                </code>
                                                            </span>
                                                            <ng-template #valueBlock>
                                                                 {{variable.valueStr}}
                                                            </ng-template>
                                                        </span>
                                                        <ng-template #mediaBlock>
                                                            <a (click)="showJson(variable);viewJsonDetail.show();" *ngIf="variable && variable.valueStr.trim().startsWith('{')">
{{variable.valueStr.substring(0,10)}}...
                                                            </a>
                                                            <a (click)="showImage(variable);viewImageDetail.show();" *ngIf="variable && variable.metaData && variable.metaData['content-type'] == 'image/jpeg'">
                                                                <img [src]="variable.valueStr" style="max-width:100px"/>
                                                            </a>
                                                            <video #videoSource controls preload="none" *ngIf="variable && variable.metaData && (variable.metaData['content-type'] == 'video/mp4' || variable.metaData['content-type'] == 'application/octet-stream')">
                                                                <source [src]="variable.valueStr">
                                                            </video>
                                                        </ng-template>
                                                    </span>
                                                </div>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>  
                        </tab>
                        <tab heading="Timelapse" *ngIf="analysis.timeLapseList">
                             <div class="card mt-2 bg-emphasis bg-opacity-25">
                                <div class="card-body" *ngIf="analysis && analysis.timeLapseList && (analysis.timeLapseList | keyvalue).length > 0">
                                    <div *ngFor="let ts of analysis?.timeLapseList | keyvalue">
    
                                            <smart-image-list [showMetaData]="true"
                                                [showZones]="false" [images]="ts.value">
                                            </smart-image-list>
                                                 
                                    </div>  
                                </div>  
                            </div>  
                        </tab>
                        <tab heading="Map" (selectTab)="mapTabSelected($event)">
                            <div class="card mt-2 bg-emphasis bg-opacity-25">
                                <div class="card-body">
                                    <open-street-map #streetMap [style]="'height:600px'" [mapheight]="'700px'"></open-street-map>
                                    <p>Right click to select item</p>
                                </div>
                            </div>  
                        </tab>
                    </tabset>

                </div>
            </div>
        </div>

        <div class="col-lg-4">
            <div class="card bg-emphasis bg-opacity-15">
                <div class="card-body">
                    <div class="d-flex fw-bold small mb-3">
                        <span class="flex-grow-1">
                            <app-time-period [(period)]="analysis.period" (periodChange)="updateAll()"></app-time-period>
                        </span>                    
                        <span class="fixed-buttons">
                            <button class="btn btn-outline-default btn-sm" (click)="loadDashboards();saveToDashboard.show()" title="Save to Dashboard" *ngIf="azureAuthService.isDashboardEditor()" [disabled]="analysis.timeSeriesList.length == 0">
                                <i class="bi bi-save"></i>
                            </button>
                            <button class="btn btn-outline-default btn-sm" (click)="startDownload()" title="Download as CSV" [disabled]="analysis.timeSeriesList.length == 0">
                                <i class="bi bi-cloud-download"></i>
                            </button>
                            <button class="btn btn-outline-default btn-sm" (click)="updateAll()" title="Refresh" [disabled]="analysis.timeSeriesList.length == 0">
                                <i class="bi bi-arrow-repeat"></i>
                            </button>
                        </span>
                    </div>

                    <hr class="mb-2"/>
                    <button class="btn btn-outline-link" *ngIf="analysis.timeSeriesList && analysis.timeSeriesList.length > 0" (click)="clearAllTimeSeries()">Clear All</button>
                    
                    <div class="list-group">
                        <div class="list-group-item align-items-center bg-emphasis bg-opacity-25" *ngFor="let ts of analysis.timeSeriesList">
                            <div class="row">
                                <div class="col-12 d-flex fw-bold small mb-3">
                                    <span class="flex-grow-1">
                                        <button [style.background]="ts.colour" [cpPosition]="'bottom'" [(colorPicker)]="ts.colour" (colorPickerClose)="updateSeries(ts)" class="colour-picker-button" [cpPresetLabel]="'Standard'" [cpPresetColors]="app.colours"></button>
                                        <span>{{ts.result.siteName}}<span *ngIf="ts.result.siteDescription"> - {{ts.result.siteDescription}}</span></span>
                                        <br *ngIf="ts.item.name"/>
                                        <small class="m-l-sm" *ngIf="ts.name == null" (title)="ts.item.description">{{ts.item.name}}</small>
                                        <small class="m-l-sm" *ngIf="ts.name != null" (title)="ts.item.name + ':' + ts.item.description">{{ts.name}}</small>
                                        <br *ngIf="ts.data && ts.data.aggregated && (ts.transforms == null || ts.transforms.length == 0)"/>
                                        <small class="m-l-sm badge bg-warning" *ngIf="ts.data && ts.data.aggregated && (ts.transforms == null || ts.transforms.length == 0)">Data Automatically Aggregated</small>
                                    </span>                    
                                    <span>
                                        <a class="collapse-link" (click)="toggle(ts)">
                                            <i class="bi" [ngClass]="{'bi-chevron-up':ts.toggle, 'bi-chevron-down':!ts.toggle}"></i>
                                        </a>
                                    </span>
                                </div>
                            </div>
                            <div class="row" *ngIf="ts.toggle">
                                <div class="col-12">
                                    <div class="row">
                                        <div class="col-sm-6">
                                            <label>Line Width</label>
                                            <select [(ngModel)]="ts.width" class="form-select p-xss" (change)="updateSeries(ts)" [attr.disabled]="ts.data && ts.data.values && ts.data.values.length > 0 ? null : ''">
                                                <option value="0">0</option>
                                                <option value="1">1</option>
                                                <option value="2">2</option>
                                                <option value="3">3</option>
                                            </select>
                                        </div>
                                        <div class="col-sm-6">
                                            <label>Line Style</label>
                                            <select [(ngModel)]="ts.style" class="form-select" (change)="updateSeries(ts)" [attr.disabled]="ts.data && ts.data.values && ts.data.values.length > 0 ? null : ''">
                                                <option value="solid">Solid</option>
                                                <option value="shortdash">Short Dash</option>
                                                <option value="ShortDot">Short Dot</option>
                                                <option value="ShortDashDot">Short Dash Dot</option>
                                                <option value="ShortDashDotDot">Short Dash Dot Dot</option>
                                                <option value="Dot">Dot</option>
                                                <option value="Dash">Dash</option>
                                                <option value="LongDash">Long Dash</option>
                                                <option value="DashDot">Dash Dot</option>
                                                <option value="LongDashDot">Long Dash Dot</option>
                                                <option value="LongDashDotDot">Long Dash Dot Dot</option>
                                            </select>
                                        </div>
                                        <div class="col-sm-6">
                                            <label>Graph Type</label>
                                            <select [(ngModel)]="ts.type" class="form-select p-xss" (change)="updateSeries(ts)" [attr.disabled]="ts.data && ts.data.values && ts.data.values.length > 0 ? null : ''">
                                                <option value="line">Line</option>
                                                <option value="stepline">Step Line</option>
                                                <option value="spline">Spline</option>
                                                <option value="area">Area</option>
                                                <option value="areaspline">Area Spline</option>
                                                <option value="column">Column</option>
                                                <option value="stackarea">Stacked Area</option>
                                                <option value="stackareaspline">Stacked Area Spline</option>
                                                <option value="stackcolumn">Stacked Column</option>
                                                
                                                <!--<option value="bar">Bar</option>-->
                                            </select>
                                        </div>
                                        <div class="col-sm-6">
                                            <label>Axis</label>
                                            <select [(ngModel)]="ts.axis" class="form-select" (change)="updateSeries(ts)" [attr.disabled]="ts.data && ts.data.values && ts.data.values.length > 0 ? null : ''">
                                                <option value="0">Left</option>
                                                <option value="1">Right</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <app-transform-editor [transforms]="ts.transforms"></app-transform-editor>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-7">
                                            <div class="form-group input-group-sm">
                                                <label>Functions</label>
                                                <br/>
                                                <a class="btn btn-outline-default" (click)="split(ts)" title="Split JSON into seperate series"><i class="bi bi-diagram-3"></i></a>
                                                <a class="btn btn-outline-default" (click)="duplicate(ts)" title="Duplicate"><i class="bi bi-clipboard-plus"></i></a>
                                                <a class="btn btn-outline-default ml-2" *ngIf="ts.data && ts.data.values" (click)="downloadSingleCSV(ts)" title="Download as CSV"><i class="bi bi-download"></i></a>
                                                <a class="btn btn-outline-default ml-2" type="button" [disabled]="ts.transforms && ts.transforms.length > 0" (click)="this.openAlarmEditor(ts)"><i class="bi bi-bell"></i></a>
                                                <a class="btn btn-outline-danger ml-2" (click)="removeTimeSeries(ts)"><i class="bi bi-trash" title="Remove Time Series"></i></a>
                                            </div>
                                        </div>
                                        <div class="col-sm-5">
                                            <div class="form-group input-group-sm btn-group text-end">
                                                <button class="btn btn-outline-default float-right btn-sm" (click)="updateTimeSeries(ts)">Set</button>
                                                <button class="btn btn-outline-default float-right btn-sm" (click)="applyToAll(ts)">Apply to All</button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-2">
                                        <div class="col-sm-12">
                                            <div class="input-group flex-nowrap">
                                                <input type="text" class="form-control form-control-sm" placeholder="URI" readonly="true" [(ngModel)]="ts.uri">
                                                <a class="input-group-text form-control-sm" ngxClipboard [cbContent]="ts.uri"><i class="fa fa-copy"></i></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>                
            </div>  
    </div>

    <app-alarm-editor #alarmEditor></app-alarm-editor>

    <div class="modal fade" bsModal #saveToDashboard="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog" aria-labelledby="dialog-static-name">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">SAVE TO DASHBOARD</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="saveToDashboard.hide()"></button>
                </div>
                <div class="modal-body">
                
                    <div class="form-group input-group-sm">
                        <label>Dashboard</label>
                        <select class="chosen-select form-control form-select" [(ngModel)]="selectedDashboardId">
                            <option value="">New Dashboard</option>
                            <option *ngFor="let dashboard of dashboards" [value]="dashboard.dashboardId">{{ dashboard.name }}</option>
                        </select>
                    </div>
    
                    <div class="form-group input-group-sm" *ngIf="!selectedDashboardId">
                        <label>New Dashboard Name</label>
                        <input class="form-control form-control-sm" [(ngModel)]="newDashboardName">
                    </div>
    
                </div>
                <div class="modal-footer">
                    <button class="btn btn-w-m btn-outline btn-default" (click)="saveDataAnalysis()">Save</button>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" bsModal #downloadData="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog" aria-labelledby="dialog-static-name">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">DOWNLOAD DATA</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="downloadData.hide()"></button>
                </div>
                <div class="modal-body">
                    <div class="nav-wizards-container">
                        <nav class="nav nav-wizards-1 mb-2">
                            <!-- completed -->
                            <div class="nav-item col">
                            <a class="nav-link completed" href="#" [ngClass]="{'active': downloadOptions.wizardStep >= 1}">
                                <div class="nav-no">1</div>
                                <div class="nav-text">Choose your mode</div>
                            </a>
                            </div>
                        
                            <!-- active -->
                            <div class="nav-item col">
                            <a class="nav-link" href="#" [ngClass]="{'active': downloadOptions.wizardStep >= 2}">
                                <div class="nav-no">3</div>
                                <div class="nav-text">Choose your format</div>
                            </a>
                            </div>
                        
                            <!-- disabled -->
                            <div class="nav-item col">
                            <a class="nav-link disabled" href="#" [ngClass]="{'active': downloadOptions.wizardStep >= 3}">
                                <div class="nav-no">5</div>
                                <div class="nav-text">Download</div>
                            </a>
                            </div>
                        </nav>
                    </div>
                    <div class="download-box">
                        <div class="card fade-in-right" *ngIf="downloadOptions.wizardStep == 1">
                            <div class="card-body ">
                                <h4>Choose your download mode</h4>
                                <div class="row download-option bg-opacity-20" [ngClass]="downloadOptions.mode == 'Express' ? 'bg-theme' : 'bg-light'">
                                    <div class="col-3">
                                        <button class="btn button-block" [ngClass]="downloadOptions.mode == 'Express' ? 'btn-primary' : 'btn-outline-default'" 
                                            (click)="selectDownloadMode('Express')">Express</button>
                                    </div>
                                    <div class="col-9">
                                        Express mode will download all time series data currently displayed into a single CSV file of a standard format.
                                    </div>
                                </div>
                                <div class="row download-option bg-opacity-20" [ngClass]="downloadOptions.mode == 'Advanced' ? 'bg-theme' : 'bg-light'">
                                    <div class="col-3">
                                        <button class="btn" [ngClass]="downloadOptions.mode == 'Advanced' ? 'btn-primary' : 'btn-outline-default'"
                                            (click)="selectDownloadMode('Advanced')">Advanced</button>
                                    </div>
                                    <div class="col-9 " >
                                        Advanced mode allows you to change the format and time range of the data you are downloading. The download will happen in the background and you will be notified when the data is ready to be retrieved. 
                                    </div>  
                                </div>
                            </div>
                        </div>         
                        <div class="card fade-in-right" *ngIf="downloadOptions.wizardStep == 2">
                            <div class="card-body">
                                <h4>Download Options</h4>
                                <div class="row download-option bg-opacity-20" [ngClass]="downloadOptions.format == 'Horizontal' ? 'bg-theme' : 'bg-light'">
                                    <div class="col-3">
                                        <button class="btn" [ngClass]="downloadOptions.format == 'Horizontal' ? 'btn-primary' : 'btn-outline-default'" 
                                            (click)="selectDownloadFormat('Horizontal')">Horizontal</button>
                                    </div>
                                    <div class="col-9" >
                                        The data will be downloaded in CSV format with each time series in a sperate column. The first column will contain the time stamps and the subsequent columns will contain the values for each time series.
                                    </div>  
                                </div>
                                <div class="row download-option bg-opacity-20" [ngClass]="downloadOptions.format == 'Vertical' ? 'bg-theme' : 'bg-light'">
                                    <div class="col-3">
                                        <button class="btn button-block" [ngClass]="downloadOptions.format == 'Vertical' ? 'btn-primary' : 'btn-outline-default'" 
                                            (click)="selectDownloadFormat('Vertical')">Vertical</button>
                                    </div>
                                    <div class="col-9 text">
                                        The data will be downloaded in CSV format with three columns. The first column will be the time series identifier, the second column will be the time stamp and the third column will be the value. This is useful for importing into other systems that require a vertical format.
                                    </div>
                                </div>
                            </div>
                        </div>  
                        <div class="card fade-in-right" *ngIf="downloadOptions.wizardStep == 3">
                            <div class="card-body">
                                <h4>Date Range</h4>
                                <div class="row download-options">
                                    <div class="col-sm-12">
                                        <div class="form-group input-group-sm">
                                            <div class="input-group input-daterange" id="datepicker">
                                                <input type="datetime-local" class="form-control" [ngClass]="{'is-invalid':downloadOptions.fromDate == null}" name="start" placeholder="start date" [(ngModel)]="downloadOptions.fromDate" required>
                                                <span class="input-group-text">to</span>
                                                <input type="datetime-local" class="form-control" [ngClass]="{'is-invalid':downloadOptions.toDate == null}" name="end" placeholder="end date" [(ngModel)]="downloadOptions.toDate" required>
                                            </div>
                                        </div>
                                    </div>
                                </div>  

                                <h4>Data Options</h4>
                                <div class="row download-options">
                                    <div class="col-sm-6">
                                        <div class="form-group input-group-sm">
                                            <div class="form-group input-group-sm">
                                                <input type="checkbox" class="form-check-input" [(ngModel)]="downloadOptions.includeUnitType" /> Include Unit Type
                                            </div>
                                            <div class="form-group input-grou-sm">
                                                <input type="checkbox" class="form-check-input" [(ngModel)]="downloadOptions.includeUnits" /> Include Units
                                            </div>
                                            <div class="form-group input-group-sm">
                                                <input type="checkbox" class="form-check-input" [(ngModel)]="downloadOptions.includeSite" /> Include Site Details
                                            </div>                                            
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="form-group input-group-sm">
                                            <div class="form-group mb-3">
                                                <label class="form-label" for="sendToEmail">Send Data to Email address</label>
                                                <input type="email" class="form-control" id="sendToEmail" [(ngModel)]="downloadOptions.sendDataTo" placeholder="name@example.com">
                                            </div>
                                        </div>
                                    </div>
                                </div>  
                                
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="totheleft">
                        <button class="btn btn-outline-light mr-2" 
                            (click)="downloadDataWizardPrev()" 
                            [disabled]="downloadOptions.wizardStep == 1">Previous</button>
                        <button class="btn btn-outline-light mr-2"
                            (click)="downloadDataWizardNext()" 
                            [disabled]="downloadOptions.mode == '' || downloadOptions.mode == 'Express' || downloadOptions.mode == 'Advanced' && ((downloadOptions.wizardStep == 3) || (downloadOptions.wizardStep == 2 && downloadOptions.format == ''))">Next</button>
                    </div>   
                    <div class="totheright">
                        <button class="btn btn-outline-light mr-2" (click)="cancelDownload()">Cancel</button>
                        <button class="btn btn-outline mr-2 btn-theme" 
                            (click)="downloadCsv()" 
                            [disabled]="downloadOptions.mode == '' || (downloadOptions.mode == 'Advanced' && (downloadOptions.fromDate == null || downloadOptions.toDate == null))">
                            <i class="fa fa-save"></i> Download
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" bsModal #viewImageDetail="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog" aria-labelledby="dialog-static-name">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Image Analysis</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="viewImageDetail.hide()"></button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-lg-12">
                  <div class="demo-img-container">
                    <div class="demo-img-wrapper" *ngIf="selectedPoint">
                      <img id="selectedImage" [title]="imageMessage" [src]="selectedPoint.valueStr"/>

                        <div *ngFor="let object of overlays" class="object-rectangle" style="left:{{object[0]}}%; top:{{object[1]}}%; width:{{object[2]}}%; height:{{object[3]}}%">
                          <table class="table-naked object-info">
                            <tbody>
                              <tr>
                                <td>{{object[4]}}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button (click)="viewImageDetail.hide()" class="btn btn-white">Close</button>
            </div>
          </div>
        </div>
    </div>
    
    <div class="modal fade" bsModal #viewJsonDetail="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog" aria-labelledby="dialog-static-name">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h4 id="dialog-static-name" class="modal-title pull-left">JSON Detail</h4>
              <button type="button" class="close pull-right" aria-label="Close" (click)="viewJsonDetail.hide()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-lg-12">
<code *ngIf="selectedPoint">
<pre>
    {{selectedJson}}
</pre>
</code>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button (click)="viewJsonDetail.hide()" class="btn btn-white">Close</button>
            </div>
          </div>
        </div>
    </div>

</div>

